import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {DEFAULT_ACTION} from '../../common/util/reducerUtils';
 
const checkFileErrors = (orders) => {
  return orders.some((order) => !!order.error);
};

export const clearStockOrder = () => ({
  'type': ActionTypes.CLEAR_DEALER_STOCK_ORDER,
});

export const createDealerStockOrder = (data) => apiActionCreator({
  'endpoint': '/orders/dealers',
  'authenticated': true,
  'types': [
    ActionTypes.CREATE_DEALER_STOCK_ORDER_REQUEST,
    [
      {
        'type': ActionTypes.CREATE_DEALER_STOCK_ORDER_SUCCESS,
        'payload': data,
      },
      MessageActions.addMessageBoxInfo('Pedido procesado satisfactoriamente'),
    ],
    [
      ActionTypes.CREATE_DEALER_STOCK_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const checkDealerStockOrder = (data) => apiActionCreator({
  'endpoint': '/orders/dealers/validator',
  'authenticated': true,
  'types': [
    ActionTypes.CHECK_DEALER_STOCK_ORDER_REQUEST,
    [
      ActionTypes.CHECK_DEALER_STOCK_ORDER_SUCCESS,
      (response) => {
        if (checkFileErrors(response.data)) {
          return MessageActions.addMessageBoxError(
            'Existen registros con errores.'
          );
        }

        return {'type': DEFAULT_ACTION};
      },
    ],
    [
      ActionTypes.CHECK_DEALER_STOCK_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'data': data,
});

export const getDealerNextDispatchTurn = (agency, dealer) => apiActionCreator({
  'endpoint': `/orders/dealers/${dealer}/agencies/${agency}/next-dispatch?stock=true`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_DEALER_NEXT_DISPATCH_TURN_REQUEST,
    [
      ActionTypes.GET_DEALER_NEXT_DISPATCH_TURN_SUCCESS,
    ],
    [
      ActionTypes.GET_DEALER_NEXT_DISPATCH_TURN_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
